'use client'

import { ReactNode } from 'react'

import { TPaymentMethod } from '@/entities/contract'
import { passPropsToChildren } from '@/shared/lib'
import { AlertDialog, Button, Icon } from '@/shared/ui'

import { PaymentDialog } from './dialog'
import { DIALOG, usePayment } from '../lib/payment'

export type PaymentValues = {
  roomName: string
  startDate: string
  endDate: string
  finalPayFee: number
}

type Props = PaymentValues & {
  paymentMethod: TPaymentMethod
  asChild?: boolean
  children?: ReactNode
}

export const PaymentButton = ({
  paymentMethod,
  roomName,
  startDate,
  endDate,
  finalPayFee,
  asChild,
  children,
}: Props) => {
  const { requestPayment, isDialogOpen, closeDialog } = usePayment()

  const handleClick = async () => {
    await requestPayment({
      method: paymentMethod,
    })
  }

  return (
    <>
      {(() => {
        if (asChild) {
          return passPropsToChildren(children, { onClick: handleClick })
        }

        return (
          <Button size="medium" shape="pill" fullWidth onClick={handleClick}>
            결제하기
            <Icon name="arrow-right" size={16} />
          </Button>
        )
      })()}

      <AlertDialog
        isOpen={isDialogOpen(DIALOG.ACCOUNT_NOTICE)}
        onOpenChange={closeDialog(DIALOG.ACCOUNT_NOTICE)}
        title="계좌이체를 진행해 주세요"
        content="이체가 완료되면 자동으로 계약이 확정됩니다."
      />

      <PaymentDialog
        isOpen={isDialogOpen(DIALOG.CARD_PAYMENT)}
        onOpenChange={closeDialog(DIALOG.CARD_PAYMENT)}
        roomName={roomName}
        startDate={startDate}
        endDate={endDate}
        finalPayFee={finalPayFee}
      />
    </>
  )
}
